// P:\0PJ\synforge\frontend\lib\api\media.ts v1 2026.08.26
import { api } from "./core"

export interface MediaVerifySessionPayload {
  session_id: string
  media_type: string
  original_name: string
  agenda: string
  sha256: string
  status: string
  duration: number
  clip_start: number | null
  clip_end: number | null
  select_start: number | null
  select_end: number | null
  clip_duration: number
  clip_url: string
  clip_fps: number
  max_duration: number
  select_duration: number
  needs_choice?: boolean
  choices?: { code: string; requires: string[] }[]
}

export const mediaverifyAPI = {
  fromBranch: (conversationId: number, fileNames: string | string[], agenda: string) => {
    const names = Array.isArray(fileNames) ? fileNames : [fileNames]
    return api.post<MediaVerifySessionPayload>("/mediaverify/from-branch/", {
      conversation_id: conversationId,
      file_names: names,
      file_name: names[0] || "",
      agenda,
    })
  },
  upload: (file: File) => {
    const formData = new FormData()
    formData.append("file", file)
    return api.post<MediaVerifySessionPayload>("/mediaverify/upload/", formData, {
      headers: { "Content-Type": undefined },
    })
  },
  range: (sessionId: string, mode: "first" | "range", start?: number, end?: number) =>
    api.post<MediaVerifySessionPayload>(`/mediaverify/${sessionId}/range/`, {
      mode,
      ...(mode === "range" ? { start, end } : {}),
    }),
  select: (sessionId: string, start: number) =>
    api.post<MediaVerifySessionPayload>(`/mediaverify/${sessionId}/select/`, { start }),
  mv1: (sessionId: string) =>
    api.post<MediaVerifySessionPayload>(`/mediaverify/${sessionId}/mv1/`),
  proceed: (sessionId: string) =>
    api.post<MediaVerifySessionPayload>(`/mediaverify/${sessionId}/proceed/`),
  status: (sessionId: string) =>
    api.get(`/mediaverify/${sessionId}/status/`),
}